import NotificationContext from "../context/NotificationContext";
import NotificationContainer from "./NotificationContainer";
import { ReactComponent as InfoIcon } from "../images/icons/info.svg";
import { ReactComponent as WarningIcon } from "../images/icons/warning.svg";
import { ReactComponent as ErrorIcon } from "../images/icons/error.svg";
import { ReactComponent as SuccessIcon } from "../images/icons/success.svg";
import { useCallback, useState } from "react";

const NotificationProvider = ({ children }) => {
    const config = {
        position: 'bottom-right',
        defaultAutoClose: 5000,
        // ...userConfig
    };

    const [notifications, setNotifications] = useState([]);
    const [heights, setHeights] = useState({});

    const updateHeight = useCallback((id, height) => {
        setHeights(prev => ({ ...prev, [id]: height }));
    }, []);

    const addNotification = useCallback((message, type = 'info', options = {}) => {
        const id = Math.random().toString(36).substring(2, 9);
        const autoClose = options.autoClose !== undefined ? options.autoClose : config.defaultAutoClose;
        
        const names = {
            info: {
                icon: <InfoIcon/>,
                text: "Информация"
            },
            success: {
                icon: <SuccessIcon/>,
                text: "Успешно"
            },
            warning: {
                icon: <WarningIcon/>,
                text: "Предупреждение"
            },
            error: {
                icon: <ErrorIcon/>,
                text: "Ошибка"
            },
        }

        const newNotification = {
            id,
            icon: names[type].icon,
            title: names[type].text,
            message,
            type,
            autoClose,
            isLeaving: false,
        };
      
        setNotifications(prev => {
            // Добавляем новое уведомление в начало массива
            const updated = [newNotification, ...prev];
            // Обновляем порядок для всех уведомлений
            return updated.map((item, index) => ({
                ...item,
                order: index
            }));
        });
        
        return id;
    }, [config.defaultAutoClose]);

    const startExitAnimation = useCallback((id) => {
        setNotifications(prev => prev.map(n => 
            n.id === id ? { ...n, isLeaving: true } : n
        ));
    }, []);
    const removeNotification = useCallback((id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    }, []);
    const closeNotification = useCallback((id) => {
        startExitAnimation(id);
        setTimeout(() => removeNotification(id), 300);
    }, [startExitAnimation, removeNotification]);
    const clearAll = useCallback(() => {
        notifications.forEach(n => startExitAnimation(n.id));
        setTimeout(() => setNotifications([]), 300);
    }, [notifications, startExitAnimation]);

    const api = {
        notifications,
        info: (message, options) =>  (message, 'info', options),
        success: (message, options) => addNotification(message, 'success', options),
        warning: (message, options) => addNotification(message, 'warning', options),
        error: (message, options) => addNotification(message, 'error', options),
        closeNotification,
        clearAll,
    }

    return (
        <NotificationContext.Provider value={api}>
            {children}
            <NotificationContainer
                notifications={notifications}
                heights={heights}
                // config={config}
                config={{ position: 'top-right' }}
                onClose={closeNotification}
                updateHeight={updateHeight}
            />
        </NotificationContext.Provider>
    )
}

export default NotificationProvider;
